import {Component, Input} from '@angular/core';

import { Rule } from '../services/capd.model';

@Component({
  selector: 'rule-detail-read',
  templateUrl: './rule-detail-read.component.html',
  // inputs: ['ruleDetail']
})

/**
 * This component displays the rule in a read-only state.  It has no interactions attached to it.
 */
export class RuleDetailReadOnlyComponent {
  @Input() ruleDetail: Rule;

}
